import { Component } from '@angular/core';
import { IndicatorDotComponent } from '../indicator-dot/indicator-dot.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-portal-data-element-list-indicator-element-container',
  standalone: true,
  imports: [CommonModule, IndicatorDotComponent],
  templateUrl:
    './portal-data-element-list-indicator-element-container.component.html',
  styleUrl:
    './portal-data-element-list-indicator-element-container.component.scss',
})
export class PortalDataElementListIndicatorElementContainerComponent {}
